import { useMemo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button, Col, Row } from "antd";
import styled from "styled-components";
import Title from "../../../components/Title";
import { BranchesOutlined, DownloadOutlined } from "@ant-design/icons";
import { TYPE_GET_DATE } from "../../../../helper/const";
import {
  sortDataNatcom,
  formatDataUniqueArray,
  getDateChangeTime,
  exportExcel,
} from "../../../../helper/helper";
import DashboardPages from "../../../Dashboard/DashboardPages";
import FilterTime from "../../../components/FilterTime";
import _ from "lodash";
import DashboardOverview from "../../components/DashboardOverview";

export default function Overview({ handleGetData, tabActive }) {
  const [startDate, setStartDate] = useState(
    getDateChangeTime(TYPE_GET_DATE.oneMonthAgo)
  );
  const [endDate, setEndDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));

  const { result = {} } =
    useSelector((state) => state.reducerNatcom?.data) || {};
  const { data: ntm = {} } = result;

  const datas = useMemo(() => {
    let quantity = [];
    let dataRevenue = [];

    if (_.isEmpty(ntm)) {
      return null;
    }
    let formatDataNtm = formatDataUniqueArray(ntm, "date", "hour");

    for (const property in formatDataNtm) {
      const itemQuantity = {
        type: "dataMarker",
        time: property,
        top: true,
        position: ["", 0],
        text: {
          content: "0",
        },
      };
      quantity = [...quantity, itemQuantity];
      const totalItem = formatDataNtm[property] || {};

      const item = {
        time: property,
        revenue: Number(totalItem.total_day),
        id: property,
      };

      dataRevenue = [...dataRevenue, item];
    }

    const revertDataQuantity = sortDataNatcom(quantity);
    const revertDataRevenue = sortDataNatcom(dataRevenue);

    return { quantity: revertDataQuantity, dataRevenue: revertDataRevenue };
  }, [ntm]);

  useEffect(() => {
    if (tabActive !== "1") return;

    handleGetData(startDate, endDate);
  }, [startDate, endDate, tabActive]);

  let quantityRevenue = {
    data: datas?.dataRevenue || [],
    xField: "time",
    yField: ["revenue", "revenue"],
    annotations: {
      quantity: datas?.quantity || [],
    },
  };
    const handleExportExcel = () => {
      exportExcel(ntm, "ntm_natcom")
    }
  return (
    <>
      <div
        className="position-relative d-flex justify-right mb-2 gap-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTime
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
        />
        <div className="d-flex justify-content-end">
          <Button 
            onClick={handleExportExcel} 
            className="d-flex align-items-center"
          >
            <DownloadOutlined /> 
            Export Excel
          </Button>
        </div>
      </div>
      <Container className="panel panel-sortable">
        <Title titleName="Overview">
          <BranchesOutlined />
        </Title>
        <Col span={24}>
          <Col xs={24} lg={24} className="container-item">
            <h4 className="pt-3 pe-3 pb-5">Overview revenue:</h4>
            <div className="item-chart">
              {/* <DashboardPages dataDashboard={quantityRevenue} /> */}
              <DashboardOverview
                dataDashboard={quantityRevenue}
                yField={"revenue"}
              />
            </div>
          </Col>
        </Col>
      </Container>
    </>
  );
}

const Container = styled(Row)``;
